const API_URL = process.env.REACT_APP_API_URL || 'https://panel.apluswealth.com';

export function reportError(error, context = {}) {
  try {
    const payload = {
      message: error.message || String(error),
      file: error.fileName || error.stack?.split('\n')[1]?.trim() || 'unknown',
      line: error.lineNumber || 0,
      context: JSON.stringify({
        ...context,
        url: window.location.href,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
      }),
    };
    fetch(API_URL + '/api/error-report', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).catch(() => {});
  } catch (e) {}
}

window.onerror = function(message, source, lineno, colno, error) {
  reportError(error || new Error(message), { source, lineno, colno });
};

window.addEventListener('unhandledrejection', function(event) {
  reportError(event.reason || new Error('Unhandled promise rejection'), { type: 'unhandledrejection' });
});
